import {
    getParticipantById,
    isParticipantModerator
} from '../../../react/features/base/participants/functions';

export function isAllowed(state, ownProps) {
    const localState = state || APP.store.getState();
    const id = ownProps ? ownProps.participantId : APP.conference.getMyUserId();
    const participant = getParticipantById(localState, id);

    return isParticipantModerator(participant);
}

export function isEnabled(state) {
    const localState = state || APP.store.getState();

    return isAllowed(localState) && localState['wildix/features/hints'].enabled;
}

export function isValidRatio(state) {
    const localState = state || APP.store.getState();
    const { currentUser, presetHints } = localState['wildix/features/hints'];

    if (!currentUser || !presetHints) {
        return true;
    }

    return currentUser.ratio <= presetHints.ratio;
}
